<template>
    <mainUi :pageRouterQuery="pageRouterRun" :bannerText="'最新政策'" :pageRouterPath="typeRun"></mainUi>
  </template>
  
  <script>
  
  import mainUi from '@/components/main.vue'
  
  export default {
    components: {
        mainUi
    },
    props: {
      msg: String
    },
    computed:{
        pageRouterRun(){
            let query = null 
            if(this.$route.query){
                query = this.$route.query
            }
            if(this.typeRun == 'policy'){
                query = {
                    "title":"",
                    "serviceName":"srvcosvc_policy_info_user_hot_select",
                    "type":"list",
                    "footer":"pagination",
                    "row":1,
                    "templateType":"4",
                    "pageRowNumber":10, 
                    "app":"fyzhmd",
                    "filter":true,
                    "filters":[{
                        colNames:["policy_sources_name"],
                        label:"发布口",
                        type:"select",
                        ruleType:"eq",
                        options:[{
                            name:'发改',
                            value:'发改'
                        },{
                            name:'科技',
                            value:'科技'
                        },{
                            name:'工信',
                            value:'工信'
                        },{
                            name:'农业',
                            value:'农业'
                        },{
                            name:'商务',
                            value:'商务'
                        },{
                            name:'人社',
                            value:'人社'
                        },{
                            name:'税务',
                            value:'税务'
                        },{
                            name:'其它',
                            value:'其它'
                        }]
                    },{
                        colNames:["province"],
                        label:"省份",
                        type:"v2Col",
                        ruleType:"eq",
                        options:{
                            
                        }
                    },{
                        colNames:["city"],
                        label:"城市",
                        type:"v2Col",
                        ruleType:"eq",
                        options:{
                            
                        }
                    },{
                        colNames:["policy_title","policy_industry"],
                        label:"关键字查询",
                        type:"string",
                        ruleType:"[like]",
                        placeholder:"请输入",
                        options:{

                        }
                    }]
                }
            }
            if(this.typeRun == 'briefing'){
                query = {
                    "title":"",
                    "serviceName":"srvdaq_cms_content_jianbao_select",
                    "type":"list",
                    "footer":"pagination",
                    "row":1,
                    "templateType":"5",
                    "pageRowNumber":9, 
                    "app":"daq",
                    "filter":true,
                    "filters":['policy_sources','province','city','districts']
                }
            }
            return query
        },
        typeRun(){
            return  this.$route.name
        }

    },
    data(){
        return {
            slide: 0,
            sliding: null,
            contentText:{
                subText:"企业规划",
                textList:['第一阶段2022年-2023年陕西、山西、河南3个省份，省市区三级、六个部门政策查询',
                '(1)其他20个省份、5个自治区、4个直辖市，省市区三级、六个部门政策查询。',
                '(2)陕西首10个区县建立业务联络点 (区县级)，3个省会城市']
            },
            layoutMap:[{
                title:"",
                type:"text",
                content:{
                    subText:"企业规划",
                    textList:['第一阶段2022年-2023年陕西、山西、河南3个省份，省市区三级、六个部门政策查询',
                    '(1)其他20个省份、5个自治区、4个直辖市，省市区三级、六个部门政策查询。',
                    '(2)陕西首10个区县建立业务联络点 (区县级)，3个省会城市']
                }
            },
            {
                title:"行业专业现状",
                type:"list",
                content:[]
            }]
        }
    },
    methods:{
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
 .search-bar{
    justify-content: center;
    position: relative;
    top: -40px;
    border-radius: 8px;
    height: 80px;
    list-style: none;
    & > li{
        width: calc(100% - 40px);
        form{
            display: flex;
            justify-content: space-between;
            button{
                width: 140px;
                margin-left: 10px;
            }
        }
    }
 }
  </style>
  